define('model/ProviderTimelineModel',['require','model/ProviderModel','lib/collection/TimeGroupCollection'],function (require) {

	var ProviderModel = require('model/ProviderModel');
	var TimeGroupCollection = require('lib/collection/TimeGroupCollection');

	return ProviderModel.extend({

		defaults: {
			id: ''
		},

		initialize: function() {
	        _.defaults(this, {
	            collection: new TimeGroupCollection()
	        });
	    },

	    parse: function(response) {
	        if (_.has(response, "timeCollection")) {
	            this.collection = new TimeGroupCollection(response.timeCollection, {
	                parse: true
	            });
	            delete response.timeCollection;
	        }

	        return response;
	    },

	    toJSON: function() {
	        var json = _.clone(this.attributes);
	        json.timeCollection = this.collection.toJSON();
	        return json;
	    }

	});

});

